
import TableList from "@components/templates/tablelist";
import { HttpGetErrorAccountList,HttpReprocrssBtn } from "@/service/newbigaccount";
import comExcel from '@components/templates/excelalert';
import { mapState, mapGetters } from "vuex";

import mixin from '../../minxin'

export default {
    mixins: [TableList,mixin],
    components: {
        comExcel
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            formData:{
                search:{

                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
        };
    },

    methods: {
        ajaxRequest: HttpGetErrorAccountList,

        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "revoke":
                    this.operate={
                        show: true,
                        alert: "warning",
                        params:{ids:params, costType:1},
                        title: "重处理",
                        ajaxRequest:HttpReprocrssBtn
                    }
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/newBilling/billingReceivableOrderItem/export", {"search[EQ_hostOrganizationId]":global.SYSID,
                            "search[EQ_status]":3,...this.formData},
                        {
                            executor: "request",
                            download: true,
                            method: 'get'
                        }
                    ).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary',['getBillcusorgList','getBillcusWareList','getCusproductList','getCusBillTypeList']),
        ToolsData(){
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "primary",
                },
                {
                    name: "重处理",
                    operate: "revoke",
                    theme:"warning",
                    batch:true,
                },
            ]

        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [

                {
                    label: "组织",
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getBillcusorgList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'EQ_warehouseId',
                    options: this.getBillcusWareList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '项目',
                    tag: 'vSelect',
                    key: 'EQ_lineId',
                    options: this.getCusproductList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '费用类型代码',
                    tag: 'vInput',
                    key: 'EQ_expenseCategoryCustomizeCode',
                    // options: this.getCusBillTypeList,
                    // props:{
                    //     filterable:true,
                    // },
                },

                {
                    label: '单号',
                    tag: 'vInput',
                    key: 'EQ_orderNo',
                },

                {
                    label: '结算日期',
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    style: "width:180px",
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },

            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 60,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '组织',
                    // render: (h, { row }) => this.findRenderLabel(this.getBillcusorgList, row.organizationId),
                    render:(h,{row})=>{
                        return <div>{row.organizationName}</div>
                    }
                },
                {
                    title: '费用类型代码',
                    key: 'expenseCategoryCustomizeCode',
                    // render: (h, { row }) => this.findRenderLabel(this.getCusBillTypeList, row.expenseCategoryType),
                },
                {
                    title: '单号',
                    key:'orderNo',
                },
                {
                    title: '仓库',
                    render: (h, { row }) => this.findRenderLabel(this.getBillcusWareList, row.warehouseId),
                },
                {
                    title: '项目',
                    render: (h, { row }) => this.findRenderLabel(this.getCusproductList, row.lineId) || '--',
                },

                {
                    title: '异常原因',
                    render: (h, { row }) => {
                        return <div>{row.exceptionMsg || '--'}</div>
                    }
                },
                {
                    title: '异常时间',
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },

    },

};
